import { Pipe, PipeTransform } from '@angular/core';
import { Board, BoardLink, UserRelatedBoard, BoardIdentifier, UserToBoardRelation, SocialMediaPostForBoard, Media} from '../modele/boardModel';

@Pipe({
    name: 'filterSocialMediaFeeds',
    pure: false
})
export class filterSocialMediaFeeds implements PipeTransform {
    transform(items: SocialMediaPostForBoard[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.isDisplayed == true);
    }
}
